import React, { useEffect, useState, useRef } from 'react'
import { parseString } from 'xml2js';
import DownloadTable from './DownloadTable';
import ListaLinhaValorDestacado from './ListaLinhaValorDestacado';


export default function ListaDadosBasicos(props) {

    const [valores, setValores] = useState(props.valores);
    const tableRef = useRef();

    const TableRows = () => {
        let criterio_id = null;
        const element = [];
        for (let i = 0; i < valores.length; i++) {
            const valor = valores[i];
            if (valor.criterio_id != criterio_id) {
                element.push(
                    <tr key={Math.random()} className='bg-light'>
                        <th style={{ textTransform: 'uppercase' }}>
                            <span className=''> <i class="zmdi zmdi-caret-down"></i> {valor.criterio}</span>
                        </th>
                        <td>{valor.criterio_descricao}</td>
                        {/* <td></td> */}
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                );
            }
            element.push(
                <tr key={Math.random()}>
                    <td><ListaLinhaValorDestacado valor={valor.nome} destacado={valor.destacado} cor={'#BA3BD0'} /></td>
                    <td className=""><span style={{ fontSize: '11px' }} > {valor.descricao}  </span></td>
                    {/* <td className=""> <small>{valor.fontes}</small> </td> */}
                    <td className=""> {valor.periodicidade} </td>
                    <td className=""> {valor.unidade} </td>
                    <td className="text-right"> {valor.valor} </td>
                </tr>
            );
            criterio_id = valor.criterio_id;
        }
        return element;
    }

    return (
        <>
            <DownloadTable tableRef={tableRef} template={props.valores[0]} />
            <table ref={tableRef} className="table  table-sm small table-hover" id='table_dados_basicos'>
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        {/* <th>FONTE</th> */}
                        <th>PERIODICIDADE</th>
                        <th>UNIDADE</th>
                        <th className="text-right"> DADO </th>
                    </tr>
                </thead>
                <tbody>
                    <TableRows></TableRows>
                </tbody>
            </table>
        </>
    )
}

